import { setAuth, setShowAuth } from '@/stores/auth.store.ts';
import type { TUser } from '@/types/models.ts';
import { useLogoutMutation } from '@/app/auth/api/queries.ts';

export function useLoginLogout() {
  const logoutMutation = useLogoutMutation();
  const doLogin = (user: TUser) => {
    setAuth(user);
    setShowAuth(false);
  };
  const doLogout = () => {
    logoutMutation.mutate();
  };
  return {
    doLogin,
    doLogout,
  };
}
